var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.5V21.75C1.5 21.9489 1.57902 22.1397 1.71967 22.2803C1.86032 22.421 2.05109 22.5 2.25 22.5H22.5",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 10.5H5.4375C4.91973 10.5 4.5 10.9197 4.5 11.4375V18.5625C4.5 19.0803 4.91973 19.5 5.4375 19.5H7.3125C7.83027 19.5 8.25 19.0803 8.25 18.5625V11.4375C8.25 10.9197 7.83027 10.5 7.3125 10.5Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 8.25H12.1875C11.6697 8.25 11.25 8.66973 11.25 9.1875V18.5625C11.25 19.0803 11.6697 19.5 12.1875 19.5H14.0625C14.5803 19.5 15 19.0803 15 18.5625V9.1875C15 8.66973 14.5803 8.25 14.0625 8.25Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7954 5.25H18.9204C18.4026 5.25 17.9829 5.66973 17.9829 6.1875V18.5625C17.9829 19.0803 18.4026 19.5 18.9204 19.5H20.7954C21.3132 19.5 21.7329 19.0803 21.7329 18.5625V6.1875C21.7329 5.66973 21.3132 5.25 20.7954 5.25Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartOutline);
export default __webpack_public_path__ + "static/media/bar-chart-outline.5289fdddc7a6954ec3432438e5cf28ab.svg";
export { ForwardRef as ReactComponent };